module.exports = __webpack_public_path__ + "components/wind-icon/static/SSW@2x-d647e258e83bf941584573a2a0e3dcc3.png";